(function(){

  angular.module('edxComponents')
    .component('navigationTabs', {
        restrict: 'E',
        templateUrl: '/resources/components/navigation-tabs/navigation-tabs.component.html',
        controller: [
          '$scope',
          '$rootScope',
          '$state',
          'edxReportItemService',
          'navigation',
          'navigationTabsService',
          NavigationTabsController
        ],
      controllerAs: 'vm'
    });

  function NavigationTabsController(
    $scope,
    $rootScope,
    $state,
    edxReportItemService,
    navigation,
    navigationTabs
  ) {
    var vm = this;

    vm.selectTab = selectTab;
    vm.updateTabs = updateTabs;
    vm.activeTab = activeTab;
    vm.currentTabs = currentTabs;
    vm.label = label;
    vm.$onDestroy = $onDestroy;

    $scope.currentType = null;

    /* selectTab
     * Triggered when a pane tab is clicked for the right pane.
     * From the tab-model tab update the right pane accordingly.
     */
    function selectTab(tab) {
      if(navigationTabs.activeTab && tab.id === navigationTabs.activeTab.id) { return; }

      navigation.tryNavigate().then(function() {
        navigationTabs.activeTab = tab;
        $state.go('.', {
          'pane': tab.slug,
          'order': undefined,
          'sort': undefined,
          'standards': undefined
        });
      });
    }

    function updateTabs(type, forceUpdate) {
      if ($scope.currentType === type && $scope.currentAssign === $state.params.assign && !forceUpdate) {
        return;
      }

      $scope.currentType = type;
      $scope.currentAssign = $state.params.assign;
      navigationTabs.currentTabs = navigationTabs.getTabs(type);
      navigationTabs.activeTab = _.findWhere(navigationTabs.currentTabs, {slug: $state.params.pane}) || navigationTabs.currentTabs[0];
    }

    function activeTab() {
      return navigationTabs.activeTab;
    }

    function currentTabs() {
      return navigationTabs.currentTabs;
    }

    function label() {
      return navigationTabs.getLabel($scope.currentAssign);
    }

    var itemSubscription = edxReportItemService.getItemObservable().subscribe(function (item) {
      $scope.item = item;
      updateTabs(item.type);
    });

    function updateGuardianTabs() {
      updateTabs($scope.item.type, true);
    }

    $scope.$on('updateStudentDataForGuardian', updateGuardianTabs);

    function $onDestroy() {
      itemSubscription.dispose();
    }

  }

})();
